import { requests } from "../../../api/agent";

export default {
  GetUsersByReOrgId: (params) =>
    requests.getWithParams("/appeal/getExecutorsByUser", params),
  GetReOrgInfoByUser: () => requests.get("/AppealUser/getReOrgInfoByUser"),
  GetUserExecutPosition: () => requests.get("/AppealUser/getUserExecutPosition"),
  GetAppealUserAddress: (params) => requests.getWithParams("/AppealUser/getAppealUserAddress", params),
  GetReOrgInfoByReOrgId: (params) => requests.getWithParams("/AppealUser/getReOrgInfoByReOrgId", params)
};
